module.exports = __webpack_public_path__ + "img/id_01.6b001267.png";